class NetworkService extends EventTarget {
  constructor() {
    super();
    this._isOnline = this._readBrowserState();

    if (typeof window !== 'undefined') {
      window.addEventListener('online', this._handleBrowserOnline);
      window.addEventListener('offline', this._handleBrowserOffline);
    }
  }

  _readBrowserState() {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine !== false;
  }

  getIsOnline() {
    this._isOnline = this._readBrowserState();
    return this._isOnline;
  }

  subscribe(listener) {
    const handleChange = (event) => {
      listener(event.detail);
    };

    this.addEventListener('change', handleChange);
    return () => {
      this.removeEventListener('change', handleChange);
    };
  }

  _setOnlineState(isOnline, source) {
    if (this._isOnline === isOnline) return;

    this._isOnline = isOnline;
    this.dispatchEvent(new CustomEvent('change', {
      detail: {
        isOnline,
        source,
      },
    }));
  }

  _handleBrowserOnline = () => {
    this._setOnlineState(true, 'browser-online');
  };

  _handleBrowserOffline = () => {
    this._setOnlineState(false, 'browser-offline');
  };
}

const networkService = new NetworkService();

export default networkService;